import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/shared/ui/dialog';
import { Button } from '@/shared/ui/button';

export default function DeleteAssignmentDialog({
  open,
  onOpenChange,
  assignment,
  onConfirm,
  onCancel,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Conferma Eliminazione</DialogTitle>
          <DialogDescription>
            Sei sicuro di voler cancellare questo task?
            {assignment?.description ? ` "${assignment.description}"` : ''}
          </DialogDescription>
        </DialogHeader>

        <div className="flex gap-2 pt-4">
          <Button className="flex-1 bg-[var(--warning)] text-[var(--on-primary)] hover:bg-[var(--warning)]" onClick={onConfirm}>
            Sì
          </Button>
          <Button variant="outline" className="flex-1" onClick={onCancel}>
            No
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}